import { render } from "./RiskProfilerWidget.vue?vue&type=template&id=6f103272"
import script from "./RiskProfilerWidget.vue?vue&type=script&lang=js"
export * from "./RiskProfilerWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__